import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  containerStyle: { justifyContent: 'flex-end', margin: 0, maxHeight: undefined, minHeight: undefined },
  // crossPressable: {
  //   alignItems: 'flex-end',
  //   justifyContent: 'space-between',
  //   paddingRight: scale(10),
  //   paddingVertical: scale(5),
  // },
  iconContainer: {
    backgroundColor: colors.secondary.softOrchid,
    borderRadius: scale(12),
    marginLeft: scale(20),
    padding: scale(2),
  },
  innerContainer: {
    backgroundColor: colors.neutral.cotton,
    borderTopEndRadius: scale(20),
    borderTopStartRadius: scale(20),
    paddingVertical: scale(10),
    width: '100%',
  },
  limitStyle: { marginLeft: scale(7) },
  modalIconStyle: { alignSelf: 'center', marginRight: scale(6) },
  rowStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center', // center children by default
    position: 'relative', // allow absolute positioning
  },
  centerText: {
    flex: 1,
    textAlign: 'center', // occupy remaining space so it's always centered
  },
  crossPressable: {
    position: 'absolute',
    right: 0, // stick to the end
    padding: scale(8),
  },
  subRow: { alignItems: 'center', borderWidth: 2, flexDirection: 'row' },
  tooltipBannerContainerStyle: {
    backgroundColor: colors.neutral.mist,
    marginHorizontal: scale(15),
    marginTop: scale(11),
  },
  tooltipBannerIconContainerStyle: { justifyContent: 'center' },
  tooltipBannerTextStyle: { flex: 1, paddingLeft: scale(10) },
  witdrawLimitStyle: {
    marginLeft: scale(22),
    marginTop: scale(16),
  },
  fltLstContainerStyle: {
    flex: 1,
    justifyContent: 'space-between',
    marginVertical: scale(5),
    paddingHorizontal: scale(6),
  },
  topProductsList: { flex: 1, marginBottom: scale(20) },
  boxStyle: {
    alignItems: 'center',
    aspectRatio: 1, // keeps square shape\
    justifyContent: 'center',
    width: '25%', // 4 columns
  },
});

export default styles;
